// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MN27_IDCQ2EyVagz3q2O{text-decoration:none}.MN27_IDCQ2EyVagz3q2O .wnHXt2L1djI7ausun_K8{white-space:nowrap}.rVNvvgzYxqAjXTZbdq5Z{margin-right:8px}.DrHQmkwASCIlWV0cCv0u{flex-direction:column;justify-content:center;align-items:center;gap:32px;width:760px;height:100%;display:flex}.DrHQmkwASCIlWV0cCv0u .rf315dzKEisP6zzaxvc3{flex-direction:column;align-items:center;gap:4px;display:flex}.DrHQmkwASCIlWV0cCv0u .DAzAjPtbZkIj0LbWog6l{text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alertAction": `MN27_IDCQ2EyVagz3q2O`,
	"alertActionText": `wnHXt2L1djI7ausun_K8`,
	"refreshContainer": `rVNvvgzYxqAjXTZbdq5Z`,
	"empty": `DrHQmkwASCIlWV0cCv0u`,
	"block": `rf315dzKEisP6zzaxvc3`,
	"desc": `DAzAjPtbZkIj0LbWog6l`
};
export default ___CSS_LOADER_EXPORT___;
